import { styled } from '@withjoy/joykit';
import { Close } from '@withjoy/joykit/icons';

export const CloseIcon = styled(Close)`
  cursor: pointer;
  box-sizing: content-box;
  padding: 0 8px;
`;
